import { create } from "zustand";
import { generalState, GeneralState } from "./general";
import { takeoverState, TakeoverState } from "./takeover";
import { type ColorRush, DisplayType, FastLaneSection, type FastLaneStyle } from '../types';
import { initializeState, InitializeState } from "./initialize";
import { MediaState, mediaState } from "./media";
import { SequenceState, sequenceState } from "./sequence";
import { ThemeState, themeState } from "./theme";
import { epcTagState, EpcTagState } from "./epc-tag";

export type set = (partial: (FastLaneState | Partial<FastLaneState> | ((state: FastLaneState) => (FastLaneState | Partial<FastLaneState>))), replace?: (boolean | undefined)) => void;
export type get = () => FastLaneState;

export interface FastLaneState extends InitializeState,
	GeneralState,
	TakeoverState,
	MediaState,
	SequenceState,
	ThemeState,
	EpcTagState {
	debugMode: boolean;
	enableDebugMode: () => void;

	display: DisplayType;
	entries: Array<FastLaneSection>;
	colorRush?: ColorRush;
	setColorRush: (colorRush?: ColorRush) => void;
	getColorRushEntry: (index: number) => ColorRush['entries'][number] | undefined;

	style?: FastLaneStyle;

	setEntries: (entries: Array<FastLaneSection>) => void;
	addIndexToEntries: () => void;

	takeoverSectionWidths?: Array<{
		index: number;
		width: number;
	}>
}

export const useFastLane = create<FastLaneState>()((set, get) => ({
	debugMode: false,
	enableDebugMode: () => set({ debugMode: true }),
	entries: [],
	colorRush: undefined,
	setColorRush: (colorRush) => set({ colorRush }),
	getColorRushEntry: (index) => {
		if (index === undefined) {
			return undefined;
		}

		const colorRushEntry = get().colorRush?.entries?.find(({range}) => {
			const [start, end] = range;
			return index >= start && index <= end;
		});

        return colorRushEntry;
	},
	display: "fast-lane",

	...initializeState(set, get),
	...generalState(set, get),
	...themeState(set, get),
	...takeoverState(set, get),
	...mediaState(set, get),
	...sequenceState(set, get),
	...epcTagState(set, get),

	setEntries: (entries: Array<FastLaneSection>) => {
		set({ entries });
		get().addIndexToEntries();
	},

	addIndexToEntries: () => {
		const entries = get().entries.map((entry, index) => ({ ...entry, index }));
		set({ entries });
	}
}));
